import * as React from 'react';

function SvgCloneTeam(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={13.329} height={15.365} {...props}>
      <g data-name="Group 54">
        <path
          d="M9.876 0H3.517a.557.557 0 00-.555.555v2.406H.555A.557.557 0 000 3.516v11.292a.557.557 0 00.555.555h9.349a.557.557 0 00.555-.555v-2.5h2.311a.557.557 0 00.555-.555V3.469a.546.546 0 00-.157-.389l-2.9-2.916A.539.539 0 009.876 0zm-.528 14.254H1.11V4.072h1.851v7.682a.557.557 0 00.555.555h5.831v1.944zM4.07 11.2V1.111h4.813v3.147a.557.557 0 00.555.555h2.777v6.386zm8.145-7.5H9.994V1.46l2.221 2.24z"
          data-name="Path 150"
        />
      </g>
    </svg>
  );
}

export default SvgCloneTeam;
